/** Domain of the organisation */
export const DOMAIN = 'place.tech';
/** Endpoint where the staff API is located */
export const API = '/api/staff/v1';
